import { useQuery } from "@tanstack/react-query";
import type { print } from "common/utils/models";

export type PdpDeliveryData = Omit<
  print.estimatedDelivery.CompositionDates,
  "onlyCartShipments" | "shippingCostInfo"
>;

export function usePdpDeliveryData() {
  // This hook subscribes to the PDP delivery estimates data
  // It will automatically re-render when the data is updated
  return useQuery<PdpDeliveryData | undefined>({
    queryKey: ["deliveryEstimates"],
    /* v8 ignore start -- queryFn is never invoked (enabled: false); data is set via queryClient.setQueryData */
    queryFn: () => undefined,
    /* v8 ignore end */
    // Don't fetch automatically, data is set by mutation
    enabled: false,
    // Keep the data fresh
    staleTime: Infinity
  });
}
